import { createStore } from "owa-satcheljs";

interface ProactiveReadingPaneStore {
    isThinking: boolean;
    isTriggerConditionMet: boolean;
}

export const getStore: () => ProactiveReadingPaneStore = createStore("ProactiveReadingPaneSuggestionStore", {
    isThinking: false,
    isTriggerConditionMet: false,
});
